module.exports = __webpack_public_path__ + "static/media/graysearch.54a67d82.svg";